import './LanguageWidget.css';
import EventTarget from '@scanex/event-target';

class LanguageWidget extends EventTarget {
    constructor (container, {languages = []}) {
        super();
        this._container = container;
        this._languages = languages;        
        this._container.classList.add ('noselect');
        this._container.classList.add('language-widget');
        this._container.innerHTML = `<select>${Object.keys(this._languages).map(id => `<option value="${id}">${this._languages[id]}</option>`).join('')}</select>`;
        this._stopPropagation = this._stopPropagation.bind(this);
        this._langSelect = this._container.querySelector('select');
        this._langSelect.addEventListener('change', e => {            
            let event = document.createEvent('Event');
            event.initEvent('change', false, false);
            event.detail = this._langSelect.value;
            this.dispatchEvent(event);
        });
        this._container.addEventListener('click', this._stopPropagation);
    }
    _stopPropagation (e) {
        e.stopPropagation();
    }
    set currentLanguage (value) {
        this._langSelect.value = value;
    }
    get currentLanguage () {
        return this._langSelect.value;
    }
}

export default LanguageWidget;